var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !!_vm.summaryContent
    ? _c("div", { staticClass: "analysis-summary-container" }, [
        _c("div", { staticClass: "analysis-summary-header" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-primary save-report-btn",
              attrs: { title: "Save report as JSON file" },
              on: { click: _vm.saveReport },
            },
            [
              _c("i", { staticClass: "fas fa-download" }),
              _vm._v(" Save Report "),
            ]
          ),
        ]),
        _c(
          "div",
          { ref: "summaryContent", staticClass: "analysis-summary" },
          [
            _vm._l(_vm.summaryContent, function (value, key) {
              return [
                _vm.getItemType(value) == "string"
                  ? _c(
                      "div",
                      {
                        key: `string-${key}`,
                        staticClass: "summary-item string",
                        class: key.toLowerCase(),
                      },
                      [
                        _c("span", { staticClass: "key" }, [
                          _vm._v(_vm._s(key)),
                        ]),
                        _c("span", {
                          staticClass: "value",
                          domProps: {
                            innerHTML: _vm._s(_vm.formatValue(key, value)),
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm.getItemType(value) == "object"
                  ? _c(
                      "div",
                      {
                        key: `object-${key}`,
                        staticClass: "summary-item object",
                        class: key.toLowerCase(),
                      },
                      _vm._l(value, function (itemValue, itemKey) {
                        return _c(
                          "div",
                          { key: itemKey, class: itemKey.toLowerCase() },
                          [
                            _c("span", { staticClass: "key" }, [
                              _vm._v(_vm._s(itemKey)),
                            ]),
                            _c("span", {
                              staticClass: "value",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatValue(itemKey, itemValue)
                                ),
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm.getItemType(value) == "array" &&
                key != _vm.summaryConfig["data in response"]
                  ? _c(
                      "div",
                      {
                        key: `array-${key}`,
                        staticClass: "summary-item array",
                        class: key.toLowerCase(),
                      },
                      [
                        _vm._l(value, function (item, itemIndex) {
                          return _vm._l(item, function (itemValue, itemKey) {
                            return _vm.getItemType(item) == "object"
                              ? _c(
                                  "div",
                                  {
                                    key: `${itemIndex}-${itemKey}`,
                                    staticClass: "object-item",
                                    class: itemKey.toLowerCase(),
                                  },
                                  [
                                    _vm.getItemType(itemValue) == "string"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "string",
                                            class: itemKey.toLowerCase(),
                                          },
                                          [
                                            _c("span", { staticClass: "key" }, [
                                              _vm._v(_vm._s(itemKey)),
                                            ]),
                                            _c("span", {
                                              staticClass: "value",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.formatValue(
                                                    itemKey,
                                                    itemValue
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.getItemType(itemValue) == "array" &&
                                    itemKey !=
                                      _vm.summaryConfig["data in response"]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "array",
                                            class: itemKey.toLowerCase(),
                                          },
                                          [
                                            _c("span", { staticClass: "key" }, [
                                              _vm._v(_vm._s(itemKey)),
                                            ]),
                                            _vm._l(
                                              itemValue,
                                              function (arrItem, arrItemIndex) {
                                                return _c("span", {
                                                  key: arrItemIndex,
                                                  staticClass: "value",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.formatValue(
                                                        itemKey,
                                                        arrItem
                                                      )
                                                    ),
                                                  },
                                                })
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm.getItemType(itemValue) == "array" &&
                                    itemKey ==
                                      _vm.summaryConfig["data in response"]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "array",
                                            class: itemKey.toLowerCase(),
                                          },
                                          [
                                            _c("research-data-table", {
                                              attrs: {
                                                pageID: 1,
                                                dataset:
                                                  _vm.getFilteredData(
                                                    itemValue
                                                  ),
                                                tableFormat: _vm.tableFormat,
                                                initPerPageNumber: 5,
                                                tableLegend: "",
                                                searchParameters: null,
                                                pkgData: null,
                                                pkgDataSelected: null,
                                                phenotypeMap: null,
                                                sectionId: 1,
                                                multiSectionPage: true,
                                                starItems: null,
                                                utils: _vm.utils,
                                                region: null,
                                                regionZoom: null,
                                                regionViewArea: null,
                                                colors: null,
                                                plotMargin: null,
                                              },
                                            }),
                                            !!_vm.summaryConfig["next steps"]
                                              ? _c(
                                                  "div",
                                                  [
                                                    _c("next-steps", {
                                                      attrs: {
                                                        data: _vm.getFilteredData(
                                                          itemValue
                                                        ),
                                                        config:
                                                          _vm.summaryConfig[
                                                            "next steps"
                                                          ],
                                                        utils: _vm.utils,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e()
                          })
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.getItemType(value) == "array" &&
                key == _vm.summaryConfig["data in response"]
                  ? _c(
                      "div",
                      {
                        key: `data-${key}`,
                        staticClass: "summary-item array",
                        class: key.toLowerCase(),
                      },
                      [
                        _c("research-data-table", {
                          attrs: {
                            pageID: 1,
                            dataset: _vm.getFilteredData(value),
                            tableFormat: _vm.tableFormat,
                            initPerPageNumber: 10,
                            tableLegend: "",
                            searchParameters: null,
                            pkgData: null,
                            pkgDataSelected: null,
                            phenotypeMap: null,
                            sectionId: 1,
                            multiSectionPage: true,
                            starItems: null,
                            utils: _vm.utils,
                            region: null,
                            regionZoom: null,
                            regionViewArea: null,
                            colors: null,
                            plotMargin: null,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }